import { listFields, listTicketForms } from "../../http/ticket-service";
import { HTTP_STATUS } from "../../http/constants/http.status";
import { AppConstants } from "../../constants/AppConstants";

export const generateToken = (email: string) => {
  const zendeskAuthString = `${email}/token:${process.env.REACT_APP_ZENDESK_API_TOKEN}`;
  return `Basic ${btoa(zendeskAuthString)}`;
};

const fieldMapper = (fieldsId: Array<number>, fieldsArray: Array<any>) => {
  return fieldsArray
    .filter((field) => fieldsId.includes(field.id))
    .reduce((acc, field) => {
      acc[field.id] = field;
      acc[field.id] = { ...acc[field.id], value: "", error: "" };
      return acc;
    }, {});
};

export const getFormInfo = async (email: string) => {
  try {
    // const token = generateToken(email);
    // const token = generateAdminToken();

    const [getFormResponse, fieldsResponse] = await Promise.all([
      listTicketForms(),
      listFields(),
    ]);

    if (
      !HTTP_STATUS.isSuccess(getFormResponse.status) ||
      !HTTP_STATUS.isSuccess(fieldsResponse.status)
    ) {
      throw new Error("Failed to retrieve ticket forms or fields.");
    }
    const { data: formResponseData } = getFormResponse;
    const { data: fieldsData } = fieldsResponse;
  

    const fieldObj = fieldMapper(formResponseData?.ticket_field_ids, fieldsData);

    return { formSchema: formResponseData, fieldData: fieldObj };
  } catch (error) {
    console.error("Error fetching Zendesk ticket forms or fields:", error);
    throw error;
  }
};
